

























































import {Prop, Watch} from "vue-property-decorator";
import {Stored} from 'vue-stored-prop-decorator';
import {Component, Vue} from '@/shared/component';
import {Timeout, WatchObjectProperties} from '@/shared/decorator';

import storeAchat, {AchatFilter} from '@/stores/modules/achat';
import storeFournisseur from '@/stores/modules/fournisseur';

import InputDateFilter from '@/components/Input/DateFilter.vue';
import CrudFournisseurSearch from "@/components/Crud/Fournisseur/Search.vue";
import {Fournisseur} from "@/models";

@Component({
	components: {
		InputDateFilter,
		CrudFournisseurSearch,
	}
})
export default class CrudAchatFilter extends Vue {

	@Prop({type: Boolean, default: false}) reduce!: boolean;

	@Stored(() => storeAchat) private page!: number;
	@Stored(() => storeAchat) private filters!: AchatFilter;

	private storeFournisseur = storeFournisseur

	private valueFournisseur = null;

	@WatchObjectProperties('filters', AchatFilter)
	@Timeout()
	private filtersWatcher(): void {
		this.page = 0;
		storeAchat.dispatch('getC', {filters: true});
	}

	public async mounted(): Promise<void> {
		await storeFournisseur.dispatch('getAll');
		this.valueFournisseur = storeFournisseur.state.all.data
		//this.typeWatcher();
	}

	@Watch('type')
	private typeWatcher(): void {
		this.filters.clear();

	}

}
